module.exports = __webpack_public_path__ + "assets/img/canon.7825b1d6.png";